export default "__VITE_ASSET__sFi$me6s__"